import { useCallback, useRef, useState } from 'react';
import { InsuranceListItem } from '@/components/organisms';
import { IInsuranceInfo, IInsuranceItem } from '@/types';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, SwiperOptions } from 'swiper';
import { clickEventHandler, makeTwoDimensionalArray } from '@/helpers';
import { ButtonOutline } from '@/components/atoms';
import { ButtonWrapper, Wrapper } from './CollectInsurance.styled';
import { IntersectionObserver } from '@/components/common';
import { useLoading, useDeviceId, useCommonParams } from '@/hooks';
import { COMPONENT_TYPE } from '@/const';

const swiperSettings: SwiperOptions = {
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next-insurance',
  },
  loop: true,
  autoHeight: true,
};

const CollectInsurance = (props: IInsuranceInfo) => {
  const { ads = [] } = props;
  const [deviceId] = useDeviceId();
  const commonParams = useCommonParams();
  const [, setLoading] = useLoading();
  const swiperRef = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(1);
  const insuranceList = makeTwoDimensionalArray(ads, 3);

  const handleClickInsurance = useCallback(
    async (item: IInsuranceItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,
        deviceId,
        componentName: COMPONENT_TYPE.INSURANCE,
      });
    },
    [commonParams, setLoading, deviceId],
  );
  const handleClickNextButton = () => {
    swiperRef.current && setActiveIndex(swiperRef.current.swiper.realIndex + 1);
  };

  return (
    <Wrapper>
      {ads.length > 3 && (
        <>
          <Swiper
            modules={[Navigation]}
            ref={swiperRef}
            {...swiperSettings}
            onSlideChange={handleClickNextButton}
          >
            {insuranceList.map((swiperArrayItem: IInsuranceItem[], index) => (
              <SwiperSlide key={`collect-insurance-${index}`}>
                {swiperArrayItem.map((item: IInsuranceItem, index: number) => (
                  <IntersectionObserver
                    key={`insurance-item-${index}`}
                    page={commonParams.page}
                    {...item}
                    componentName={COMPONENT_TYPE.INSURANCE}
                  >
                    <InsuranceListItem {...item} onClick={() => handleClickInsurance(item)} />
                  </IntersectionObserver>
                ))}
              </SwiperSlide>
            ))}
          </Swiper>
          <ButtonWrapper>
            <ButtonOutline
              className="swiper-button-next-insurance"
              full
              onClick={handleClickNextButton}
            >
              다음보기 {activeIndex}/
              <span style={{ color: '#CCCCCC' }}>{insuranceList.length}</span>
            </ButtonOutline>
          </ButtonWrapper>
        </>
      )}
      {ads.length <= 3 &&
        ads.map((item: IInsuranceItem, index) => (
          <IntersectionObserver
            key={`collect-insurance-${index}`}
            {...item}
            componentName={COMPONENT_TYPE.INSURANCE}
          >
            <InsuranceListItem {...item} />
          </IntersectionObserver>
        ))}
    </Wrapper>
  );
};

export default CollectInsurance;
